import React from 'react'
import styled from 'styled-components'
import {
  Wrapper,
  P,
  H,
  Grid,
  Image,
  BackgroundImageWrapper,
} from '@farewill/ui'

import data from './data'

const StyledGrid = styled(Grid)`
  align-items: center;
`

const StyledBackgroundImageWrapper = styled(BackgroundImageWrapper)`
  background-size: contain;
  padding: 8px;
`

const StyledImage = styled(Image)`
  width: 100%;
`

const MobileComponent = (): React.ReactElement => (
  <Wrapper padding={['L', 0, 0]}>
    <StyledGrid columns={12}>
      <Grid.Item span={12} spanFromM={10} startColumnFromM={2}>
        <H size="M" tag="h3">
          {data.title}
        </H>
        <P>{data.description}</P>
      </Grid.Item>
      {data.steps.map(({ content, image }) => (
        <React.Fragment key={content}>
          <Grid.Item span={4} spanFromM={2} startColumnFromM={2}>
            <StyledBackgroundImageWrapper
              imagePath="textures/blob-yellow-2"
              imageWidth={110}
              backgroundPosition="50% 50%"
            >
              <StyledImage path={image} width={110} />
            </StyledBackgroundImageWrapper>
          </Grid.Item>
          <Grid.Item span={8} spanFromM={9}>
            <P size="S">{content}</P>
          </Grid.Item>
        </React.Fragment>
      ))}
    </StyledGrid>
  </Wrapper>
)

export default MobileComponent
